import React, { ReactNode } from 'react'
import StepWizard, { StepWizardChildProps, StepWizardProps } from 'react-step-wizard'
import styled, { css } from 'styled-components'
import { WizardNav } from './Wizard.nav'

export const wizardStyles = css`
	overflow: hidden;
`

const WizardView = styled.div`
	${wizardStyles}
`

export type WizardStepProps = StepWizardChildProps & {
	// isActive?: boolean
	// currentStep?: number
	// totalSteps?: number
	// firstStep?: () => void
	// lastStep?: () => void
	// nextStep?: () => void
	// previousStep?: () => void
	// goToStep?: (step?: number) => void
	// goToNamedStep?: (step: string) => void
	// hashKey?: string | undefined
	// stepName?: string | undefined
}

export type WizardProps = Omit<StepWizardProps, 'children'> & {
	includeDots?: boolean
	scrollToTop?: boolean
	children?: ReactNode | ReactNode[]
}
export const Wizard = ({
	children,
	className,
	initialStep,
	onStepChange,
	scrollToTop,
	includeDots,
	...props
}: WizardProps) => {
	const stepWizardProps: StepWizardProps = {
		...props,
		initialStep,
		onStepChange: e => {
			if (scrollToTop) {
				const modalContent = document.getElementsByClassName('modal-scroll-container')

				for (let i = 0; i < modalContent.length; i++) {
					modalContent[i].scrollTo(0, 0)
				}
			}
			if (onStepChange) onStepChange(e)
		},
	}
	if (includeDots) stepWizardProps.nav = <WizardNav />

	return (
		<WizardView className={`wizard${className ? ` ${className}` : ''}`}>
			<StepWizard {...stepWizardProps}>{children as any}</StepWizard>
		</WizardView>
	)
}
